import { BackendHttpService } from './backendHttpService';

export interface CheckEmailExistsResponse {
  exists: boolean;
  personId: number | null;
  firstName: string | null;
  lastName: string | null;
}

export interface ImportReport {
  technologiesNotFound: string[];
  languagesNotFound: string[];
  languageLevelsNotFound: string[];
  warnings: string[];
  hasIssues: boolean;
}

export interface IntelligentImportResponse {
  personId: number;
  report: ImportReport;
}

export class ImportService extends BackendHttpService {
  constructor() {
    super('import');
  }

  async checkEmailExists(email: string): Promise<CheckEmailExistsResponse> {
    try {
      const response = await this.get<CheckEmailExistsResponse>(`CheckEmailExists?email=${encodeURIComponent(email)}`);
      return response;
    } catch (error) {
      console.error('Error checking if email exists:', error);
      throw error;
    }
  }

  async importFromCvPartnerFile(file: File): Promise<string> {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await this.postFormData<FormData, string>(formData, 'cvpartner');
      return response;
    } catch (error) {
      console.error('Error importing from CV Partner file:', error);
      throw error;
    }
  }

  async importFromSharepointFile(file: File): Promise<number> {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await this.postFormData<FormData, number>(formData, 'sp');
      return response;
    } catch (error) {
      console.error('Error importing from Sharepoint file:', error);
      throw error;
    }
  }

  async intelligentImport(
    file: File | null,
    firstName?: string,
    lastName?: string,
    email?: string,
    image?: string | null,
    officeLocation?: string,
    confirmOverwrite?: boolean
  ): Promise<IntelligentImportResponse> {
    try {
      const formData = new FormData();

      if (file) {
        formData.append('File', file);
      }

      if (firstName) {
        formData.append('FirstName', firstName);
      }

      if (lastName) {
        formData.append('LastName', lastName);
      }

      if (email) {
        formData.append('Email', email);
      }

      if (image) {
        formData.append('Image', image);
      }

      if (officeLocation) {
        formData.append('OfficeLocation', officeLocation);
      }

      if (confirmOverwrite !== undefined) {
        formData.append('ConfirmOverwrite', confirmOverwrite.toString());
      }

      const response = await this.postFormData<FormData, IntelligentImportResponse>(formData, 'IntelligentImport');
      return response;
    } catch (error) {
      console.error('Error during intelligent import:', error);
      throw error;
    }
  }
} 
